import React from 'react';
import TopCategories from '../swiper/topCategories';

export default function ({ highlightsfeed, eleRef }) {
    return (
        <section className="main_container_block_feeds">
                                <div className="main_block_container_feed top_categories_2">
                                   <div className="heading_top_categories R15_61">
                                       {highlightsfeed.title?highlightsfeed.title:''} ({highlightsfeed.topCategoryCount?highlightsfeed.topCategoryCount:''})
                                    </div>
                                    <div className="content-div-box-top_categories2">
                                           <TopCategories page={"dr-carousel-unit"} data={highlightsfeed.data} />
                                    </div>
                                </div>
                             </section>
    )
}
